import React from 'react';
import Sidebar from 'components/Sidebar';
import {
    Accordion, AccordionActions, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, ButtonGroup,
    Card, CardContent, CardHeader, Dialog, DialogContent, DialogContentText, DialogTitle, FormLabel, Grid, IconButton, Menu, MenuItem, Stack, TextField, Typography
} from '@mui/material';
import DatePicker from "react-datepicker";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import settingDelete from "assets/icons/settingDelete.svg";
import accordianBtn from "assets/icons/accordianBtn.svg";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel';
import { advantagePlanSelectType, documentTypes } from '../Inspection-NotRan/data';
import NoViolationDatatable from './datatable';
import '../Inspection-NotRan/inspection.css';
import { NotificationManager } from 'react-notifications';
import API from '../../Api';
import LogModal from './log_modal';
import { userActivity } from '../../activity/userActivity';
import _ from 'lodash';
import bug from '../../assets/icons/Frame.svg';
import edit from '../../assets/icons/settingEdit.svg';
import openDoc from '../../assets/icons/openDoc.svg';
import trash from '../../assets/icons/settingDelete.svg';
import download from '../../assets/icons/download.svg';
import { socketInstance } from '../../socket/connection';
import Loader from 'react-loader-spinner';
import cancel from '../../assets/icons/cancel.svg';
import ClaimNoteHistory from 'components/RuleProcessor/noteHistory';

let user = JSON.parse(sessionStorage.getItem("userDetail"));
let practice = JSON.parse(sessionStorage.getItem('practice'));

class PatientDetails extends React.Component {
    constructor(props) {
        super(props);
        this.autoCAssignRef = React.createRef();
        this.assigntoHint = "";
        this.state = {
            isOther: false,
            selectValue: '',
            rules: [],
            bugRuleId: '',
            bugRuleName: '',
            errorDescription: '',
            showEligibilityResponse: false,
            showPatientDetails: true,
            // reviewChecked: JSON.parse(localStorage.getItem('isReviewd')), // props.location.state.trizettoData[0].isReviewed,
            // reviewChecked: this.props?.location?.state?.isReviewed,
            reviewChecked: null,
            viewedDetail: sessionStorage.getItem('viewedDetail'),
            token: JSON.parse(sessionStorage.getItem("token")).token,
            advantagePlanModal: false,
            advantagePlans: [],
            searchKey: 'contractNumber',
            searchValue: this.props?.location?.state?.eligibilityData[0]?.contractNumber ? this.props?.location?.state?.eligibilityData[0]?.contractNumber : '',
            bugModal: false,
            RPA_response_data: null,
            finalResult: this.props?.location?.state?.eligibilityData[0]?.isPassed === true,
            SSN: '',
            openPatientModal: false,
            whatsNeededCS: [],
            assignTo: [],
            assigntoValue: "",
            updateWorklistDetails: {
                Note: '',
                AssignedTo: "",
                WhatsNeeded: "",
                DueDate: "",
                id: [this.props?.location?.state?.instanceId]
            },
            newWorklistDetails: {
                Note: '',
                AssignedTo: "",
                WhatsNeeded: "",
                DueDate: "",
                id: ""
            },
            anchorEl: null,
            noteRequired: {
                visible: false,
                tagName: ""
            },
            openNotePopup: false,
            viewHistoryData: null,
            documentType: '',
            documents: []
        }
        // Create a ref for the hidden file input
        this.fileInputRef = React.createRef();
    }

    // function to toggle eligibility response visibility
    handleToggle = () => {
        this.setState({
            showEligibilityResponse: !this.state.showEligibilityResponse,
            showPatientDetails: !this.state.showPatientDetails
        })
    }
    onClose = () => {
        this.setState({
            showPatientDetails: true,
            showEligibilityResponse: false
        });
    }

    // function to handle advantage plan modal
    openAdvantagePlanModal = () => {
        this.setState({ advantagePlanModal: true }, () => {
            this.searchAdvantagePlans(this.state.searchKey, this.state.searchValue);
            // this.getAdvantagePlans();
        })
    }
    closeAdvantagePlanModal = () => {
        this.setState({ advantagePlanModal: false, searchKey: '', searchValue: this.props.location.state.eligibilityData[0].contractNumber, advantagePlans: [] })
    }

    // function to get advantage plan list
    getAdvantagePlans = () => {
        API.get('getAdvantagePlanList').then((response) => {
            let advantagePlanList = response.data.data;
            this.setState({ advantagePlans: advantagePlanList })
        }).catch(err => {
            console.error(err)
        })
    }

    // logic to search advantage plans by dropdown selection
    handleSelectChange = e => {
        let value = advantagePlanSelectType.filter(item => {
            return item.key === e.target.value
        })
        // if (this.state.searchValue !== '') {
        //     this.searchAdvantagePlans();
        // }
        this.setState({
            searchKey: value ? value[0].key : 'contractNumber',
            // searchValue: ''
        });
    }

    handleInputChange = (event) => {
        this.setState({ searchValue: event.target.value }, () => {
            this.searchAdvantagePlans(this.state.searchKey ? this.state.searchKey : 'contractNumber', this.state.searchValue);
            // this.searchAdvantagePlans(this.state.searchKey ? this.state.searchKey : 'contractNumber', this.state.searchValue ? this.state.searchValue : this.state.contractNumber);
        });
    }

    searchAdvantagePlans = _.debounce(() => {
        this.setState({ rules: [] });
        API.get('searchInAdvantagePlanList', { params: { [this.state.searchKey ? this.state.searchKey : 'contractNumber']: this.state.searchValue } }).then((response) => {
            // API.get('searchInAdvantagePlanList', { params: { [this.state.searchKey ? this.state.searchKey : 'contractNumber']: this.state.searchValue ? this.state.searchValue : this.state.contractNumber } }).then((response) => {
            // console.log(response.data);
            let advantagePlans = response.data.data;
            this.setState({ advantagePlans: advantagePlans });
        }).catch(err => {
            console.error(err);
        })
    }, 1000);

    // function to redirect to insurance page
    linkEdi = (id, linkedStatus) => {
        // console.log(this.props.location.state.chargeData);
        let chargeData = this.props.location.state.allChargeData;

        const linkedData = chargeData.filter(f => f.EncounterID === id).map(item => {
            const obj = {}
            obj["pName"] = item.payerName;
            obj["pId"] = item.payerId;
            obj["linkedPayer"] = item.PrimaryInsurancePlanName;
            obj["linkedPayerId"] = item.PrimaryInsurancePolicyPlanID;

            return obj;
        })
        if (!linkedData.length) return;
        const { PrimaryInsurancePlanName, PrimaryInsurancePolicyPlanID } = chargeData[0]
        // console.log("linkedData", chargeData)
        this.props.history.push({
            pathname: `/insurances/${id}/${PrimaryInsurancePolicyPlanID}/${localStorage.getItem("isPrimary") === "true" ? "Primary" : "Secondary"}`,
            state: {
                chargeData: chargeData,
                linkedData: linkedData,
                insuranceType: localStorage.getItem("isPrimary") === "true" ? "Primary" : "Secondary",
                PrimaryInsurancePlanName: PrimaryInsurancePlanName
            }
        });
    }

    // function to handle edit rule
    handleEdit = (id) => {
        let processedRules = this.props.location.state.trizettoData;
        // console.log('processedRules', processedRules);
        let violatedRules = processedRules.filter(item => item.ruleSuccess === false);
        // console.log('violatedRules', violatedRules);
        let editViolatedRule = violatedRules.filter(item => item.ruleId === id);
        // console.log('editViolatedRule', editViolatedRule);
        let length = editViolatedRule[0].encounterRuleResult.ruleData.ruleInfo.length;
        let obj = {
            for: editViolatedRule[0].encounterRuleResult.ruleData.ruleInfo[length - 1].operator,
            pendValue: editViolatedRule[0].encounterRuleResult.ruleData.result,
            reason: editViolatedRule[0].encounterRuleResult.ruleData.Reason,
            operator: "none"
        }
        editViolatedRule[0].encounterRuleResult.ruleData.ruleInfo.push(obj);
        this.props.history.push({
            pathname: `/edit-rule/${id}`,
            state: {
                editRule: true,
                ruleDetail: editViolatedRule[0].encounterRuleResult.ruleData,
                tags: editViolatedRule[0].encounterRuleResult.tags,
                ruleId: id,
                from: 'patient-details',
                path: `/edit-rule/${id}`,
            }
        });

    }

    // Function to add our give data into cache
    addDataIntoCache = (cacheName, url, response) => {
        const data = new Response(JSON.stringify(response));
        if ('caches' in window) {
            caches.open(cacheName).then((cache) => {
                cache.put(url, data);
            });
        }
    }

    updateReviewStatus = (isReviewed, id) => {
        return new Promise((resolve, reject) => {
            API.post('updateReviewStatus', { isReviewed, id }).then((res) => {
                if (res.data.code === 200 && res.data.success === true) {
                    resolve(res)
                }
            }).catch((error) => {
                reject(false)
            })
        })
    }

    handleBugModal = (rule) => {
        this.setState({
            bugModal: !this.state.bugModal,
            logModalOpen: false,
            bugRuleId: rule.ruleId,
            bugRuleName: rule?.encounterRuleResult?.ruleName
        }, () => {
            this.getRules();
        });
    }

    getRules = (practiceType = false) => {
        API.get(
            "getAllBugRules" + "?practiceId=0"
        )
            .then((response) => {
                let rules = response.data.data;
                this.setState({
                    rules: rules ? rules : [],
                });
            })
            .catch((err) => {
                console.error(err);
            });
    };

    closeBugModal = () => {
        this.setState({
            selectValue: '',
            isOther: false,
            bugModal: false
        })
    }

    handleSelectOption = (e) => {
        const { value } = e.target;
        if (value == 'other') {
            this.setState({ isOther: true });
        } else {
            this.setState({ isOther: false });
        }
        this.setState({ selectValue: value });
    }

    falseBugReport = () => {
        try {
            let rule = this.props.location.state.trizettoData;
            let bugRule = rule.filter(item => item.ruleId === this.state.bugRuleId);

            let body_data = {
                encounterId: bugRule[0].EncounterID,
                ruleId: this.state.bugRuleId,
                errorDescription: this.state.errorDescription
            }
            API.post('bugReportByFalseViolation', body_data).then((res) => {
                console.log(res.data);
                NotificationManager.success("Reported Bug Successfully", 'Success', 3000);
                this.setState({
                    bugModal: false,
                    logModalOpen: false,
                    bugRuleId: '',
                    bugRuleName: '',
                    errorDescription: ''
                });
            })
        } catch (err) {
            console.error(err);
        }
    }

    // function to handle change
    handleInputChange = (e) => {
        const { errors } = this.state;
        errors[e.target.name] = '';
        this.setState({ [e.target.name]: e.target.value, errors });
    }

    // function to get patient details
    getSSN = () => {
        const { state } = this.props.location;
        let data = {
            customerKey: practice.key,
            user: practice.email,
            password: practice.password,
            practiceName: practice.practiceName,
            isSSN: true,
            patientId: state?.chargeData?.PatientID
        }
        API.post('kareo/getSSN', data).then((res) => {
            console.log(res)
            if (res.data.success === true) {
                const ssn = res.data.result;
                this.setState({
                    SSN: ssn,
                });
            } else {
                NotificationManager.error('Patient not found for the given practice', 'Failed!', 3000);
            }
        }).catch(err => {
            console.error(err);
        })
    }

    // function to handle checkbox selection
    handleCheckboxClick = (event, row = null) => {
        let incomingVal = event.target.value;
        const { name } = event.target;

        switch (name) {
            case "worklistNote":
            case "WhatsNeeded":
                // Dynamic key update for Note or WhatsNeeded
                this.setState((prevState) => ({
                    updateWorklistDetails: {
                        ...prevState.updateWorklistDetails,
                        [name === "worklistNote" ? "Note" : "WhatsNeeded"]: incomingVal
                    }
                }));
                break;
            default:
                console.log("wrong key selection");
        }
    };

    // function to get whats needed values
    getWhatsNeeded = async () => {
        let result = await API.get("/getClaimActions/claimScrubber")
        let whatsNeededItems = []
        result.data.forEach((item) => {
            whatsNeededItems.push({
                key: item.id,
                value: item.items
            })
        })
        this.setState({ whatsNeededCS: whatsNeededItems })
    }

    // function to get user list
    getAssignedUsers = () => {
        API.get("/getAssignToUsers?tableType=rule-processor").then((result) => {
            if (result.data.success === true && result.data.userList.length) {
                let userArr = ["Danish", "Pappu", "puneet", "Monu", "Saurabh"]
                let userList = result.data.userList.filter(item => !userArr.includes(item.first_name));
                this.setState({ assignTo: userList });
            }
        }).catch((error) => {
            NotificationManager.error("Something Went wrong!", "Failure!", 3000);
        });
    };

    resetState = (stateName) => {
        // Accessing the DOM via createRef() requires using .current
        const autoCautoCAssignRefEle = this.autoCAssignRef.current?.getElementsByClassName('MuiAutocomplete-clearIndicator')[0];
        if (autoCautoCAssignRefEle) {
            autoCautoCAssignRefEle.click();
        }

        // Common assignments for both branches
        this.assigntoHint = "";

        if (stateName === "resetButtonHandle") {
            this.setState((prevState) => ({
                assigntoValue: "",
                updateWorklistDetails: {
                    Note: '',
                    AssignedTo: "",
                    WhatsNeeded: "",
                    DueDate: "",
                    id: prevState.updateWorklistDetails.id, // Preserve id from previous state
                    worklistRows: []
                }
            }));
        }

        if (stateName === "updateWorklistDetails") {
            this.setState({
                checkboxForAllRows: false,
                assigntoValue: "",
                updateWorklistDetails: {
                    Note: '',
                    AssignedTo: "",
                    WhatsNeeded: "",
                    DueDate: "",
                    id: [],
                    worklistRows: []
                }
            });
        }
    };

    // function to update worklist rows based on inputs
    updateWorklistData = () => {
        const { updateWorklistDetails } = this.state;

        // 1. Note validation - If empty, show the popup
        if (!updateWorklistDetails.Note || updateWorklistDetails.Note.trim().length === 0) {
            NotificationManager.error("Note is required!", "Failure!", 2000);
            // this.setState({
            //     noteRequired: {
            //         tagName: 'note',
            //         visible: true, // This triggers your popup component
            //     }
            // });
            return;
        }

        // 3. Validation passed: execute update
        this.updateData();
    };

    updateData = () => {
        const { updateWorklistDetails } = this.state;

        // Construct payload with the 4 specific fields + id
        const payload = {
            id: updateWorklistDetails.id,
            Note: updateWorklistDetails.Note,
            AssignedTo: updateWorklistDetails.AssignedTo,
            WhatsNeeded: updateWorklistDetails.WhatsNeeded,
            DueDate: updateWorklistDetails.DueDate
        };

        API.put("/updateClaimData", payload).then((result) => {
            console.log(result.data)
            if (result.data && result.data.success === true) {
                NotificationManager.success(
                    "Rows updated successfully",
                    "Successful!",
                    2000
                );

                // Reset form state
                this.resetState("updateWorklistDetails");
                this.getUpdatedActions()
            }
        }).catch(error => {
            NotificationManager.error("Update failed", "Error");
            console.error(error);
        });
    };

    // function to handle note required pop up
    handleNoteRequired = () => {
        this.setState({ noteRequired: !this.state.noteRequired.visible })
    }

    // Toggles the modal visibility and initializes data
    handleNotePopup = () => {
        const { updateWorklistDetails, viewHistoryData } = this.state;
        this.setState({
            openNotePopup: true,
            viewHistoryData
        });
    };

    // Close handler for the modal
    handleClosePopup = () => this.setState({ openNotePopup: false });

    // function to handle assign back functionality
    assignBack = () => {
        const { updateWorklistDetails } = this.state;
        let body_data = {
            id: updateWorklistDetails.id,
            Note: updateWorklistDetails.Note,
            assignBack: true
        }
        API.post('/assignBackToUser', body_data).then(res => {
            console.log(res.data)
        }).catch(err => {
            console.error(err)
        })
    }

    // function to get updated actions
    getUpdatedActions = () => {
        const { state } = this.props?.location;
        const patient = state?.chargeData;
        const claimId = state?.chargeData?.id;
        API.get(`/getPatientActions/${claimId}`).then((res) => {
            let data = res.data.noteData;
            let actionData = res.data.latestValue
            let noteData = [];
            noteData.push({
                notes: data,
                PatientName: patient?.PatientName,
                SchedulingProviderName: patient?.SchedulingProviderName,
                ServiceLocationName: patient?.ServiceLocationName,
                EncounterID: patient?.EncounterID,
                ProcedureCode: patient?.ProcedureCode,
                ServiceStartDate: patient?.ServiceStartDate
            })
            this.setState({
                viewHistoryData: noteData,
                newWorklistDetails: {
                    AssignedTo: actionData?.AssignedTo,
                    WhatsNeeded: actionData?.whatsNeed,
                    DueDate: actionData?.DueDate,
                    CommittedBy: actionData?.CommitedBy,
                    id: [actionData?.ClaimId]
                }
            });
        }).catch(err => {
            console.error(err);
        });
    }

    /* function to upload documents */
    // Step 1: Trigger the hidden file input when the UPLOAD button is clicked
    handleUploadButtonClick = () => {
        if (!this.state.documentType) {
            NotificationManager.error("Please select document type", "Error", 2000)
        } else {
            this.fileInputRef.current.click();
        }
    };

    // Step 2: Handle file selection and immediately call the API
    handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Optional: Additional client-side validation for file type
        const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
        if (!allowedTypes.includes(file.type)) {
            NotificationManager.error("Only PDF and Word documents are allowed.", "Error", 2000);
            return;
        }
        const { state } = this.props?.location;
        let patientId = state?.chargeData?.PatientID;

        // Prepare the payload using FormData
        const formData = new FormData();
        formData.append('patientId', patientId);
        formData.append('file', file);
        formData.append('documentName', file.name);
        formData.append('documentType', this.state.documentType);
        formData.append('fileType', file.type);

        try {
            // Replace with your actual API endpoint
            const res = await API.post('upload/patientDocuments', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            this.getDocuments();
        } catch (error) {
            console.error("Upload failed:", error);
        }
    };

    // function to get uploaded documents
    getDocuments = () => {
        const { state } = this.props?.location;
        let patientId = state?.chargeData?.PatientID;
        let body_data = {
            patientId: patientId
        }
        API.post('/retrive/patientDocuments', body_data).then(res => {
            let docs = res.data.data;
            this.setState({ documents: docs })
        }).catch(err => {
            console.error(err)
        })
    }

    // function to delete a document from list
    deleteDocument = (docId) => {
        const { state } = this.props?.location;
        let patientId = state?.chargeData?.PatientID;

        let body_data = {
            patientId: patientId,
            documentId: docId
        }
        API.post('/remove/patientDocuments', body_data).then(res => {
            console.log(res)
            this.getDocuments();
        }).catch(err => {
            console.error(err)
        })
    }

    // function to view / download document
    retrieveDocument = (s3Bucket, s3Key, docType, type, docName) => {
        let body_data = {
            s3Bucket: s3Bucket,
            s3Key: s3Key,
            documentType: docType,
            contentType: 'application/pdf' || 'application/msword' || 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            mode: type,
            docName: docName
        }
        API.post('/retrive/signedURL', body_data).then(res => {
            const docUrl = res?.data?.data;
            if (docUrl) {
                if (type === 'view') {
                    // --- VIEW LOGIC ---
                    const newWindow = window.open(docUrl, '_blank', 'noopener,noreferrer');
                    if (newWindow) newWindow.focus();
                }
                else if (type === 'download') {
                    // --- DOWNLOAD LOGIC ---
                    // We create a temporary hidden anchor to trigger the browser download
                    const link = document.createElement('a');
                    link.href = docUrl;
                    link.click();
                }
            } else {
                console.error("No URL returned from API");
            }
        }).catch(err => {
            console.error(err)
        })
    }

    componentDidMount() {
        // 1. Get value from localStorage
        const savedStatus = localStorage.getItem('isReviewd');
        console.log(savedStatus)

        // 2. Get value from props as fallback
        const propStatus = this.props?.location?.state?.isReviewed;

        // 3. Logic: If local storage exists, convert string to boolean. 
        // Otherwise, use propStatus.
        const finalStatus = (savedStatus || savedStatus !== null)
            ? (savedStatus === 'true' ? true : false)
            : !!propStatus;

        this.setState({ reviewChecked: finalStatus });

        (async () => {
            if (this.state.viewedDetail === '0') {
                var activity = new userActivity('Viewed Detail ', this.state.token)
                await activity.setActivityAPI({ encounterID: this.props.location.state.trizettoData[0].EncounterID });
                sessionStorage.setItem('viewedDetail', '1')
            }
        })()
        let socket = socketInstance()
        if (socket) {
            socket.emit('checkRPAStatus', {
                practiceId: this.props.location.state.chargeData.PracticeID,
                encounterId: this.props.location.state.trizettoData[0].EncounterID,
                instanceID: this.props.location.state.trizettoData[0].instanceID,
            });
            socket.on('checkRPAStatus', (data) => {
                // console.log(data)
                if (data.status === false) {
                    return;
                } else {
                    if (data.data[0]) {
                        this.setState({
                            RPA_response_data: data.data[0]
                        })
                        if (data.data[0].rpaStatus === 'received and success') {
                            if ('encounterStatus' in data) {
                                if (data.encounterStatus === 'Approved') {
                                    this.setState({
                                        reviewChecked: 'true',
                                        finalResult: true
                                    })
                                    // localStorage.setItem('isReviewd', 'true')
                                    return;
                                }
                                if (data.encounterStatus === false) {
                                    let multiPracticeRules = this.props.location.state.trizettoData.filter(item => item.practiceId === '0');
                                    let practiceRules = this.props.location.state.trizettoData.length - multiPracticeRules.length;
                                    socket.emit('checkRPAStatus', {
                                        practiceId: this.props.location.state.chargeData.PracticeID,
                                        encounterId: this.props.location.state.trizettoData[0].EncounterID,
                                        instanceID: this.props.location.state.trizettoData[0].instanceID,
                                        ruleViolationCount: practiceRules - (this.state.RPA_response_data?.rpaResponse?.ruleFixed ? this.state.RPA_response_data?.rpaResponse?.ruleFixed : 0)
                                    });
                                }
                            }
                        }
                    }
                }
                socket.emit('checkRuleViolationStatus', {
                    practiceId: this.props.location.state.chargeData.PracticeID,
                    encounterId: this.props.location.state.trizettoData[0].EncounterID,
                    instanceID: this.props.location.state.trizettoData[0].instanceID,
                });
            })
            socket.on('checkRuleViolationStatus', (data) => {
                if (data.stopGoBack == true) {
                    this.props.history.goBack()
                }
            });
        }
        // this.getRules()
        this.getAssignedUsers()
        this.getWhatsNeeded()
        this.getUpdatedActions()
        this.getDocuments();
    }

    render() {
        const { showEligibilityResponse, showPatientDetails, advantagePlanModal, advantagePlans, rules, bugModal, isOther, selectValue, SSN,
            patientData, assignTo, updateWorklistDetails, whatsNeededCS, noteRequired, openNotePopup, viewHistoryData, newWorklistDetails,
            documentType, documents } = this.state;
        const { state } = this.props?.location;
        const data = state?.chargeData;
        const procedureData = state?.allChargeData;
        // console.log(procedureData)
        let last_log = state?.rulesRanBy[0];
        // console.log(data)
        const status = state?.trizettoData;
        const elStatus = state?.eligibilityData;
        const ruleRunData = state?.trizettoData[0]
        // console.log(elStatus);
        let ranDate = new Date(elStatus[0]?.currentTime)?.toLocaleDateString('en-US');
        // console.log(ruleRunData);

        let date = new Date(elStatus[0]?.currentTime);
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        let ranTime = hours + ':' + minutes + ' ' + ampm;


        let multiPracticeRules = status.filter(item => item.practiceId === '0');
        let practiceRules = status.length - multiPracticeRules.length;

        let isRPA = status.filter(item => item?.encounterRuleResult?.result === 'Run RPA Flow');

        let dueDate = newWorklistDetails?.DueDate && data?.DueDate.split('-');
        let formattedDueDate = dueDate && `${dueDate[1]}/${dueDate[2]}/${dueDate[0]}`;

        const cardStyle = {
            border: '1px solid #D8D8D8',
            borderRadius: '9px',
            width: '95%',
            textAlign: 'left'
        }
        const headerStyle = {
            borderBottom: '1px solid darkgrey',
            height: 40
        }
        const heading = {
            fontSize: '20px'
        }
        const textStyle = { textDecoration: 'none', color: '#00708C', cursor: 'pointer' }

        let num = 0;

        let rejectReason = elStatus && elStatus[0]?.eligibilityData && elStatus[0]?.eligibilityData?.inforeceiver && elStatus && elStatus[0]?.eligibilityData?.inforeceiver[0]?.rejection ?
            <span>{elStatus[0]?.eligibilityData?.inforeceiver[0]?.rejection[0]?.rejectreason[0]}</span> :
            elStatus[0]?.eligibilityData && elStatus[0]?.eligibilityData?.infosource && elStatus && elStatus[0]?.eligibilityData?.infosource[0]?.rejection ?
                <span>{elStatus[0]?.eligibilityData?.infosource[0]?.rejection[0]?.rejectreason[0]}</span> :
                elStatus && elStatus[0]?.eligibilityData && elStatus[0]?.eligibilityData?.dependent && elStatus && elStatus[0]?.eligibilityData?.dependent[0]?.rejection ?
                    <span>{elStatus[0]?.eligibilityData?.dependent[0]?.rejection[0]?.rejectreason[0]}</span> :
                    elStatus && elStatus[0]?.eligibilityData && elStatus[0]?.eligibilityData?.subscriber && elStatus && elStatus[0]?.eligibilityData?.subscriber[0]?.rejection ?
                        <span>{elStatus[0]?.eligibilityData?.subscriber[0]?.rejection[0]?.rejectreason[0]}</span> :
                        elStatus && elStatus[0]?.eligibilityData && elStatus[0]?.eligibilityData?.subscriber && elStatus && elStatus[0]?.eligibilityData?.subscriber[0]?.benefit ?
                            <span>{elStatus[0]?.eligibilityData?.subscriber[0]?.benefit[0]?.info[0]}</span> :
                            elStatus && elStatus[0]?.eligibilityData && elStatus[0]?.eligibilityData?.dependent && elStatus && elStatus[0]?.eligibilityData?.dependent[0]?.benefit ?
                                <span>{elStatus[0]?.eligibilityData?.dependent[0]?.benefit[0]?.info[0]}</span> :
                                elStatus && elStatus[0]?.eligibilityData && elStatus[0]?.eligibilityData["soap:Envelope"] &&
                                    elStatus[0]?.eligibilityData["soap:Envelope"]["soap:Body"] &&
                                    elStatus[0]?.eligibilityData["soap:Envelope"]["soap:Body"][0]?.DoInquiryResponse[0]?.DoInquiryResult[0]?.SuccessCode[0] === 'PayerNotSupported' ?
                                    // <span>{"Enrollment Pending"}</span> :'Unable to Check'
                                    <span>{"Payer Not Supported"}</span> :
                                    (elStatus && elStatus[0]?.eligibilityData && elStatus[0]?.eligibilityData["soap:Envelope"] &&
                                        elStatus[0]?.eligibilityData["soap:Envelope"]["soap:Body"] &&
                                        elStatus[0]?.eligibilityData["soap:Envelope"]["soap:Body"][0]?.DoInquiryResponse[0]?.DoInquiryResult[0]?.SuccessCode[0] === 'ValidationFailure' ||
                                        elStatus && elStatus[0]?.eligibilityData && elStatus[0]?.eligibilityData["soap:Envelope"] &&
                                        elStatus[0]?.eligibilityData["soap:Envelope"]["soap:Body"] &&
                                        elStatus[0]?.eligibilityData["soap:Envelope"]["soap:Body"][0]?.DoInquiryResponse[0]?.DoInquiryResult[0]?.SuccessCode[0] === 'ProviderNotOnFile') ?
                                        <span>{"Group NPI Not on File"}</span> :
                                        elStatus && elStatus[0]?.eligibilityData && elStatus[0]?.eligibilityData["soap:Envelope"] &&
                                            elStatus[0]?.eligibilityData["soap:Envelope"]["soap:Body"] &&
                                            elStatus[0]?.eligibilityData["soap:Envelope"]["soap:Body"][0]?.DoInquiryResponse[0]?.DoInquiryResult[0]?.SuccessCode[0] === 'PayerTimeout' ?
                                            <span>{"Payer Timeout"}</span> : 'Unable to Check'

        // console.log(String(this.state.reviewChecked))

        return (
            <section>
                <Sidebar defaultDisabledValue={data?.PracticeID} />
                <div className='action-layout'>
                    <div className='action-header'>

                        <div className='text-start'><span class="page-heading">Actions</span></div>

                        <div className="ruleout-grid mb-2">
                            <div>
                                <div className="font-face-futura text-start noteDiv">
                                    <span className="px-1">Note</span>
                                    <textarea
                                        placeholder="Write what was done to fix the claim..."
                                        className="p-2 denialNote w-100"
                                        name="worklistNote"
                                        value={updateWorklistDetails.Note}
                                        onChange={this.handleCheckboxClick}
                                    />
                                </div>
                            </div>
                            <div className="d-flex flex-column justify-content-center gap-3">
                                <div className={`ruleout-grid-three ${user?.roleId == 9 ? "external-user" : ""}`}>
                                    <div>
                                        <span className="denial-forminput">
                                            <label className="text-nowrap">Assigned To</label>
                                            <Autocomplete
                                                className="justify-content-start autocomplete-select2"
                                                ref={this.autoCAssignRef}
                                                onKeyDown={(event) => {
                                                    if (event.key === "Tab") {
                                                        if (this.assigntoHint) {
                                                            const hintValue = this.assigntoHint;
                                                            this.setState((prevState) => ({
                                                                assigntoValue: hintValue,
                                                                updateWorklistDetails: {
                                                                    ...prevState.updateWorklistDetails,
                                                                    AssignedTo: hintValue,
                                                                },
                                                            }));
                                                            event.preventDefault();
                                                        }
                                                    }
                                                }}
                                                onClose={() => {
                                                    this.assigntoHint = "";
                                                }}
                                                onChange={(event, newValue) => {
                                                    const formattedName = newValue && newValue.id
                                                        ? `${newValue.first_name} ${newValue.last_name}`
                                                        : "";
                                                    const assignedId = newValue && newValue.id ? newValue.id : "";

                                                    this.setState((prevState) => ({
                                                        assigntoValue: formattedName,
                                                        updateWorklistDetails: {
                                                            ...prevState.updateWorklistDetails,
                                                            AssignedTo: assignedId,
                                                        },
                                                    }));
                                                }}
                                                blurOnSelect
                                                inputValue={this.state.assigntoValue}
                                                id="combo-box-hint-demo-"
                                                options={assignTo} // Assuming assignTo is in state
                                                getOptionLabel={(option) =>
                                                    option ? `${option.first_name} ${option.last_name}${option.roleid === 9 ? " (External User)" : ""}` : ""
                                                }
                                                renderInput={(params) => {
                                                    return (
                                                        <Box className="autocompleteselect2-container">
                                                            <TextField
                                                                className="autocompleteinput-container"
                                                                {...params}
                                                                onChange={(event) => {
                                                                    const newValue = event.target.value;

                                                                    // Update text state and details object
                                                                    this.setState((prevState) => ({
                                                                        assigntoValue: newValue,
                                                                        updateWorklistDetails: {
                                                                            ...prevState.updateWorklistDetails,
                                                                            AssignedTo: newValue,
                                                                        },
                                                                    }));

                                                                    // Logic for hint (replacing assigntoHint.current)
                                                                    const matchingOption = assignTo.find(
                                                                        (option) =>
                                                                            option.first_name.startsWith(newValue) ||
                                                                            option.last_name.startsWith(newValue)
                                                                    );

                                                                    if (newValue && matchingOption) {
                                                                        this.assigntoHint =
                                                                            matchingOption.first_name + " " + matchingOption.last_name;
                                                                    } else {
                                                                        this.assigntoHint = "";
                                                                    }
                                                                }}
                                                                placeholder="Select"
                                                            />
                                                        </Box>
                                                    );
                                                }}
                                            />
                                        </span>
                                    </div>
                                    {user?.roleId != 9 && <><div>
                                        <span className="denial-forminput">
                                            <label className="text-nowrap">What's Needed</label>
                                            <select
                                                name="WhatsNeeded"
                                                value={updateWorklistDetails.WhatsNeeded}
                                                onChange={this.handleCheckboxClick}
                                                className="denialSelect2">
                                                <option value="" disabled selected>
                                                    Select
                                                </option>
                                                {whatsNeededCS.map((item) => (
                                                    <option key={item.key} value={item.key}>
                                                        {item.value}
                                                    </option>
                                                ))}
                                            </select>
                                        </span>
                                    </div>
                                        <div>
                                            <span className="denial-forminput">
                                                <label className="text-nowrap">Due Date</label>
                                                <DatePicker
                                                    className="denialSelect2"
                                                    format={"MM-dd-yyyy"}
                                                    placeholderText="MM/DD/YYYY"
                                                    name="DueDate"
                                                    selected={updateWorklistDetails.DueDate}
                                                    onChange={(date) => {
                                                        this.setState((prevState) => ({
                                                            updateWorklistDetails: {
                                                                ...prevState.updateWorklistDetails,
                                                                DueDate: date
                                                            }
                                                        }));
                                                    }}
                                                />
                                            </span>
                                        </div></>}
                                </div>
                                <div className="denial-buttons justify-content-end">
                                    <Button
                                        className="text-white resetBtn"
                                        variant="contained" onClick={() => {
                                            this.props.history.goBack();
                                            localStorage.removeItem('isReviewd')
                                        }}>
                                        <span className="text-capitalize font-face-futura">
                                            CLOSE
                                        </span>
                                    </Button>
                                    <Button
                                        className="text-white resetBtn"
                                        variant="contained" onClick={this.handleNotePopup}>
                                        <span className="text-capitalize font-face-futura">
                                            NOTES
                                        </span>
                                    </Button>
                                    {/* <Button
                                        className="text-white resetBtn"
                                        variant="contained">
                                        <span className="text-capitalize font-face-futura">
                                            LOG
                                        </span>
                                    </Button> */}
                                    <LogModal encounterID={this.props?.location?.state?.trizettoData[0]?.EncounterID} />
                                    <Button
                                        className="text-white resetBtn"
                                        onClick={() => this.resetState("resetButtonHandle")}
                                        variant="contained">
                                        <span className="text-capitalize font-face-futura">
                                            RESET
                                        </span>
                                    </Button>
                                    <Button
                                        className="text-white saveButn"
                                        variant="contained"
                                        onClick={this.updateWorklistData}
                                    >
                                        <span className="text-capitalize font-face-futura">
                                            SAVE
                                        </span>
                                    </Button>
                                    {user?.roleId == 9 ? <Button
                                        className="text-white saveButn"
                                        variant="contained"
                                        onClick={this.assignBack}>
                                        <span className="text-capitalize font-face-futura">ASSIGN BACK</span>
                                    </Button> :
                                        <Button
                                            className='subheader_review_btn saveButn checkbtn-last'
                                            variant='contained'>
                                            <label class="checkbox-container patient-checkbox">
                                                {/* <input type="checkbox" name="checkboxForAllRows" value="true" checked={String(this.state.reviewChecked) === 'true' ? true : false} */}
                                                <input type="checkbox" name="checkboxForAllRows" value="true" checked={this.state.reviewChecked !== null ? this.state.reviewChecked : data.isMarkReviewed}
                                                    onChange={async () => {
                                                        const currentVal = this.state.reviewChecked !== null ? this.state.reviewChecked : data.isMarkReviewed;
                                                        const nextVal = !currentVal;
                                                        const response = await this.updateReviewStatus(nextVal, data.instanceID);
                                                        // const response = await this.updateReviewStatus(this.state.reviewChecked.toString() === 'true' ? false : true, data.id);
                                                        if (response) {
                                                            NotificationManager.success('Updated successfully', 'Success', 2000)
                                                            localStorage.setItem('isReviewd', nextVal.toString())
                                                            this.setState({
                                                                reviewChecked: nextVal
                                                                // reviewChecked: response.data.data
                                                            })
                                                            var activity = new userActivity(nextVal ? 'Mark as review' : 'Marked as Not Reviewed', this.state.token)
                                                            // var activity = new userActivity(this.state.reviewChecked.toString() === 'true' ? 'Mark as review' : 'Marked as Not Reviewed', this.state.token)
                                                            let activityResponse = await activity.setActivityAPI({ encounterID: this.props.location.state.trizettoData[0].EncounterID });
                                                            if (!activityResponse.success)
                                                                NotificationManager.error(activityResponse.message, 'Error!', 2000)
                                                        } else {
                                                            NotificationManager.error('Data cannot be updated', 'Error!', 2000)
                                                        }
                                                    }} />
                                                <span class="checkmark"></span>  Mark as Reviewed
                                            </label>
                                            {/* <div class="form-check patient-checkbox">
                                                {
                                                    String(this.state.reviewChecked) == 'true' ? <input type="checkbox"  class="form-check-input" id="check-round" checked={true} /> : <input type="checkbox"  class="form-check-input" id="check-round" checked={false} />
                                                }
                                                <label class="form-check-label" for="check-round">
                                                   Mark as Reviewed
                                                </label>
                                            </div> */}
                                        </Button>}
                                </div>
                            </div>
                            {noteRequired.visible && (
                                <Dialog
                                    fullWidth
                                    open={noteRequired.visible}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <div align="center" className="avatar3">
                                        <CancelIcon
                                            className="dialogCancel"
                                            fontSize="large"
                                        />
                                    </div>
                                    <div
                                        align="center"
                                        className="dialog-box3 dialog-box-denail"
                                    >
                                        <DialogTitle id="alert-dialog-title">
                                            <span className="font-face-futura dialogTitle dialogTitlefontSize">
                                                {(noteRequired.tagName || "").toUpperCase()}{" "}
                                                REQUIRED
                                            </span>
                                        </DialogTitle>
                                        <DialogContent>
                                            <DialogContentText id="alert-dialog-description ">
                                                <span className="font-face-futura dialogText">
                                                    A {noteRequired.tagName} is required before
                                                    changing this claim's status
                                                </span>
                                            </DialogContentText>
                                            <Button
                                                fullWidth
                                                className="mt-4 dialogBtn"
                                                variant="contained"
                                                onClick={this.handleNoteRequired}
                                            >
                                                <span className="font-face-futura">GO BACK</span>
                                            </Button>
                                        </DialogContent>
                                    </div>
                                </Dialog>
                            )}
                            <ClaimNoteHistory
                                openNote={openNotePopup}
                                // The close handler needs to be distinct from the open handler
                                closeNotePopup={this.handleClosePopup}
                                viewData={viewHistoryData}
                            />
                        </div>
                    </div>

                    <div className='action-accordion'>
                        <Accordion defaultExpanded className='bg-transparent single-accordion'>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3-content"
                                id="panel3-header"
                            >
                                <Typography component="span" >Patient Demographics</Typography>
                            </AccordionSummary>
                            <AccordionDetails className='px-0'>
                                <div className='row g-2'>
                                    <div className='col-md-6 col-xxl-3'>
                                        <Card className='demoCard h-100' variant='outlined' >
                                            <CardHeader className='demoCardHead' title={<h6 className='text-start font-face-futura mb-0'><strong>Patient Demographics</strong></h6>} />
                                            <CardContent className='demoContent p-2'>
                                                <div className='row'>
                                                    <div className="col-6">
                                                        <Box className="action-detail" >
                                                            <FormLabel >Name</FormLabel>
                                                            <Typography >
                                                                {data.PatientName}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className="col-6">
                                                        <Box className="action-detail" >
                                                            <FormLabel >Patient ID</FormLabel>
                                                            <Typography >
                                                                {data.PatientID}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className="col-6">
                                                        <Box className="action-detail" >
                                                            <FormLabel >Gender</FormLabel>
                                                            <Typography >
                                                                {data.Gender == "F" ? "Female" : "Male"}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className="col-6">
                                                        <Box className="action-detail" >
                                                            <FormLabel >Date of Birth</FormLabel>
                                                            <Typography >
                                                                {data.PatientDateOfBirth} <span>({data.Age})</span>
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className="col-6">
                                                        <Box className="action-detail" >
                                                            <FormLabel >Social Security Number</FormLabel>
                                                            <Stack direction="row" spacing={2}>
                                                                <Typography style={{ width: 100, letterSpacing: SSN ? 1 : 4 }}>
                                                                    {SSN || '***_**_****'}
                                                                </Typography>
                                                                <VisibilityIcon className='opacity-25' style={{ cursor: 'pointer' }} onClick={this.getSSN} />
                                                                {/* <VisibilityOffIcon /> */}
                                                            </Stack>
                                                            <Button variant="text" className='btn p-0 pt-1 getssnbtn'>Get SSN</Button>
                                                        </Box>
                                                    </div>
                                                    <div className='col-6'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Address</FormLabel>
                                                            <Typography >
                                                                {data.AddressLine1 + ' ' + data.AddressLine2}
                                                            </Typography>
                                                            <Typography >
                                                                {data.City + ' ' + data.Country + ' ' + data.ZipCode}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </div>
                                    <div className='col-md-6 col-xxl-3'>
                                        <Card className='demoCard h-100' variant='outlined' >
                                            <CardHeader className='demoCardHead' title=
                                                {
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <h6 className='text-start font-face-futura mb-0'>
                                                            <strong>Eligibility Status</strong>

                                                        </h6>
                                                        <div className='eligibile-checkboxcontainer'>
                                                            <label class="checkbox-container patient-checkbox">
                                                                <input type="checkbox" name="checkboxForAllRows" value="true" />
                                                                <span class="checkmark"></span>  Eligibility Bypass
                                                            </label>
                                                        </div>
                                                    </div>
                                                } />
                                            <CardContent className='demoContent p-2'>
                                                <div className='row'>
                                                    <div className="col-12 mb-3">
                                                        <Box className="action-detail" >
                                                            <FormLabel >Case Name</FormLabel>
                                                            <Typography >
                                                                {data.CaseName}
                                                            </Typography>
                                                        </Box>
                                                    </div>

                                                    <div className="col-6 eligibility-container">
                                                        <Typography variant="h6" className=' page-heading fw-bold'>
                                                            Primary Insurance
                                                        </Typography>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Plan Name</FormLabel>
                                                            <Typography >
                                                                {data.PrimaryInsurancePlanName}
                                                            </Typography>
                                                        </Box>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Policy</FormLabel>
                                                            <Typography >
                                                                {data.PrimaryInsurancePolicyNumber}
                                                            </Typography>
                                                        </Box>

                                                    </div>
                                                    <div className="col-6 eligibility-container">
                                                        <Typography variant="h6" className='page-heading fw-bold'>
                                                            Secondary Insurance
                                                        </Typography>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Plan Name</FormLabel>
                                                            <Typography >
                                                                {data.SecondaryInsurancePlanName}
                                                            </Typography>
                                                        </Box>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Policy</FormLabel>
                                                            <Typography >
                                                                {data.SecondaryInsurancePolicyNumber}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-12'>
                                                        <Box className="action-detail" >
                                                            <FormLabel>
                                                                <span className='d-flex'>Eligibility Status &nbsp;
                                                                    {elStatus[0]?.runEligibilityForPrimary === true ?
                                                                        <>{elStatus[0]?.eligibilitySuccess === true ? '' : (elStatus[0]?.eligibilitySuccess === false && data.PrimaryInsuranceLinkedStatus === true && elStatus[0]?.rejectedReason === '') ?
                                                                            <p style={textStyle}
                                                                                onClick={(id) => { this.linkEdi(data.EncounterID, data.PrimaryInsuranceLinkedStatus); localStorage.setItem("isPrimary", true) }}>Edit EDI</p> :

                                                                            (elStatus[0]?.eligibilitySuccess === false && data.PrimaryInsuranceLinkedStatus === false) ?
                                                                                <p style={textStyle}
                                                                                    onClick={(id) => { this.linkEdi(data.EncounterID, data.PrimaryInsuranceLinkedStatus); localStorage.setItem("isPrimary", true) }}>Link EDI</p> :

                                                                                ((elStatus[0]?.eligibilitySuccess === false) && (data.PrimaryInsuranceLinkedStatus === true) && (elStatus[0]?.rejectedReason === 'Contact Following Entity')) ?
                                                                                    <p style={textStyle}
                                                                                        onClick={this.openAdvantagePlanModal}>View Advantage Plan Directory</p> : ''}
                                                                        </> :
                                                                        <>{data.PrimaryInsuranceLinkedStatus === true ?
                                                                            <p style={textStyle}
                                                                                onClick={(id) => { this.linkEdi(data.EncounterID, data.PrimaryInsuranceLinkedStatus); localStorage.setItem("isPrimary", true) }}>Edit EDI</p> :
                                                                            <p style={textStyle}
                                                                                onClick={(id) => { this.linkEdi(data.EncounterID, data.PrimaryInsuranceLinkedStatus); localStorage.setItem("isPrimary", true) }}>Link EDI</p>}
                                                                        </>}
                                                                </span>
                                                            </FormLabel>
                                                            <div className='d-flex align-items-center gap-2 justify-content-start mb-1'>
                                                                <Typography className='eligibilitystatus-active '>
                                                                    <span style={{ textDecoration: 'none', color: data.PrimaryInsurancePlanName && elStatus[0]?.eligibilitySuccess === true ? '#5CB02C' : '#954437' }}>
                                                                        {this.props.location.state.isBypassed === true ? 'Bypassed' : data.PrimaryInsurancePlanName && elStatus[0]?.eligibilitySuccess === true ? 'Active' :
                                                                            (data.PrimaryInsurancePlanName && elStatus[0]?.eligibilitySuccess === false && elStatus[0]?.rejectedReason === 'Non Citizens') ? 'Non Citizen' :
                                                                                (data.PrimaryInsurancePlanName && elStatus[0]?.eligibilitySuccess === false && elStatus[0]?.rejectedReason === 'NO PART B') ? 'No Part B Benefits' :
                                                                                    (data.PrimaryInsurancePlanName && elStatus[0]?.eligibilitySuccess === false && elStatus[0]?.rejectedReason === 'Contact Following Entity') ? 'Medicare Advantage Plan' :
                                                                                        (data.PrimaryInsurancePlanName && elStatus[0]?.eligibilitySuccess === false && elStatus[0]?.rejectedReason === 'MCO') ? 'Advantage Plan' :
                                                                                            (data.PrimaryInsurancePlanName && elStatus[0]?.eligibilitySuccess === false && elStatus[0]?.isPolicyNumberPresent === false) ? 'Unable to check' : rejectReason}
                                                                    </span>
                                                                    <br />
                                                                    {/* {elStatus[0]?.runEligibilityForPrimary === true ?
                                                                    <>{elStatus[0]?.eligibilitySuccess === true ? '' : (elStatus[0]?.eligibilitySuccess === false && data.PrimaryInsuranceLinkedStatus === true && elStatus[0]?.rejectedReason === '') ?
                                                                        <p style={textStyle}
                                                                            onClick={(id) => { this.linkEdi(data.EncounterID, data.PrimaryInsuranceLinkedStatus); localStorage.setItem("isPrimary", true) }}>Edit EDI</p> :

                                                                        (elStatus[0]?.eligibilitySuccess === false && data.PrimaryInsuranceLinkedStatus === false) ?
                                                                            <p style={textStyle}
                                                                                onClick={(id) => { this.linkEdi(data.EncounterID, data.PrimaryInsuranceLinkedStatus); localStorage.setItem("isPrimary", true) }}>Link EDI</p> :

                                                                            ((elStatus[0]?.eligibilitySuccess === false) && (data.PrimaryInsuranceLinkedStatus === true) && (elStatus[0]?.rejectedReason === 'Contact Following Entity')) ?
                                                                                <p style={textStyle}
                                                                                    onClick={this.openAdvantagePlanModal}>View Advantage Plan Directory</p> : ''}
                                                                    </> :
                                                                    <>{data.PrimaryInsuranceLinkedStatus === true ?
                                                                        <p style={textStyle}
                                                                            onClick={(id) => { this.linkEdi(data.EncounterID, data.PrimaryInsuranceLinkedStatus); localStorage.setItem("isPrimary", true) }}>Edit EDI</p> :
                                                                        <p style={textStyle}
                                                                            onClick={(id) => { this.linkEdi(data.EncounterID, data.PrimaryInsuranceLinkedStatus); localStorage.setItem("isPrimary", true) }}>Link EDI</p>}
                                                                    </>}
                                                                {elStatus[0]?.rejectedReason?.includes('keywords') &&
                                                                    <p className='cardText'>Keyword(s) Flagged:&nbsp;
                                                                        <span style={{ 'fontWeight': '400' }}>Eligibility {JSON.parse(elStatus[0]?.rejectedReason)?.flag} <span style={{ color: '#954437' }}>"{JSON.parse(elStatus[0]?.rejectedReason)?.keywords?.join(", ")}"</span></span>
                                                                    </p>
                                                                } */}
                                                                </Typography>
                                                                <Button variant="text" className='btn p-0 getssnbtn text-capitalize'>View Report</Button>
                                                            </div>
                                                            {(elStatus[0]?.rejectedReason?.includes('keywords') && JSON.parse(elStatus[0]?.rejectedReason)?.keywords.length) ?
                                                                <p className='cardText'>Keyword(s) Flagged:&nbsp;
                                                                    <span style={{ 'fontWeight': '400' }}>Eligibility {JSON.parse(elStatus[0]?.rejectedReason)?.flag}
                                                                        <span style={{ color: '#954437' }}>{" "}"{JSON.parse(elStatus[0]?.rejectedReason)?.keywords?.join(", ")}"</span>
                                                                    </span>
                                                                </p> : null
                                                            }
                                                        </Box>
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </Card>
                                        {advantagePlanModal && <Dialog fullWidth
                                            maxWidth="lg" className='dialogHeight'
                                            open={advantagePlanModal}
                                            // onClose={this.closeAdvantagePlanModal}
                                            aria-labelledby="alert-dialog-title"
                                            aria-describedby="alert-dialog-description">
                                            <div align="center" className='planTitle'>
                                                <DialogTitle id="alert-dialog-title">
                                                    <span className='font-face-futura'>{"Advantage Plan Directory"}</span>
                                                </DialogTitle>
                                            </div>
                                            <DialogContent>
                                                <DialogContentText id="alert-dialog-description">
                                                    <div align="center" className='font-face-futura planDesc'>This list comes from Medicare and helps you identify which advantage plan the patient has.</div>
                                                </DialogContentText>
                                                <div className='mt-2'>
                                                    <Card className='planCard'>
                                                        <CardHeader className='planCardHead' title={<h5 className="text-white font-face-futura">Search</h5>} />
                                                        <CardContent className='planContent'>
                                                            <div className="row">
                                                                <div className='col-lg-6 col-sm-6'>
                                                                    <label htmlFor="group" className='cardLabel'>Search Type:</label>
                                                                    <select fullWidth className='px-2 text' onChange={this.handleSelectChange}>
                                                                        {advantagePlanSelectType.map((plan, key) => (
                                                                            <option key={key} value={plan.key}>{plan.value}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className='col-lg-6 col-sm-6'>
                                                                    <label htmlFor="group" className='cardLabel'>Search:</label><br />
                                                                    <input type='text' className="p-2 text"
                                                                        value={this.state.searchValue}
                                                                        onChange={this.handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </CardContent>
                                                    </Card>
                                                    <Card className="mt-2 planCard">
                                                        <CardHeader className='planCardHead'
                                                            title={<h5 className="text-white font-face-futura">Advantage Plans</h5>} />
                                                        <CardContent className='planContent planContentHeight'>
                                                            <div className='table-responsive tableManager font-face-futura'>
                                                                <table className='table managerTable'>
                                                                    <thead>
                                                                        <tr>
                                                                            <th className="text-center text-white">Legal Entity Name</th>
                                                                            <th className="text-center text-white">Marketing Name</th>
                                                                            <th className="text-center text-white">Contract Number</th>
                                                                            {/* <th className="text-center text-white">Effective Date</th> */}
                                                                            <th className="text-center text-white">Contact Number</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {advantagePlans && advantagePlans.map((plan) => (
                                                                            <tr>
                                                                                <td className="text-center py-2 px-0 font15">{plan.legalEntityName}</td>
                                                                                <td className="text-center py-2 px-0 font15">{plan.marketingName}</td>
                                                                                <td className="text-center py-2 px-0 font15">{plan.contractNumber}</td>
                                                                                {/* <td className="text-center py-2 px-0 font15">{plan.effectiveDate}</td> */}
                                                                                <td className="text-center py-2 px-0 font15">{plan.contactNumber}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </CardContent>
                                                    </Card>
                                                    <footer>
                                                        <div className='actionButton'>
                                                            <Button fullWidth
                                                                className="mt-4 mb-2 mx-2 looksgood"
                                                                variant="outlined" onClick={this.closeAdvantagePlanModal}>
                                                                <span className="text-white font-face-futura" style={{ fontSize: 18 }}>Thanks!</span>
                                                            </Button>
                                                        </div>
                                                    </footer>
                                                </div>
                                            </DialogContent>
                                        </Dialog>}
                                    </div>
                                    <div className='col-md-6 col-xxl-2'>
                                        <Card className='demoCard h-100' variant='outlined' >
                                            <CardHeader className='demoCardHead' title={<h6 className='text-start font-face-futura mb-0'><strong>Patient Contact Info</strong></h6>} />
                                            <CardContent className='demoContent p-2'>

                                                <Box className="action-detail" >
                                                    <FormLabel >Home Phone</FormLabel>
                                                    <Typography >
                                                        {data.HomePhone}
                                                    </Typography>
                                                </Box>
                                                <Box className="action-detail" >
                                                    <FormLabel >Work Phone</FormLabel>
                                                    <Typography >
                                                        {data.WorkPhone}
                                                    </Typography>
                                                </Box>
                                                <Box className="action-detail" >
                                                    <FormLabel >Mobile Phone</FormLabel>
                                                    <Typography >
                                                        {data.MobilePhone}
                                                    </Typography>
                                                </Box>
                                                <Box className="action-detail" >
                                                    <FormLabel >Email</FormLabel>
                                                    <Typography >
                                                        {data.EmailAddress}
                                                    </Typography>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </div>
                                    <div className='col-md-6 col-xxl-2 '>
                                        <Card className='demoCard h-100' variant='outlined' >
                                            <CardHeader className='demoCardHead' title={<h6 className='text-start font-face-futura mb-0'><strong>Other Info</strong></h6>} />
                                            <CardContent className='demoContent p-2'>

                                                <Box className="action-detail" >
                                                    <FormLabel >Patient Alert</FormLabel>
                                                    <div className='patient-alertscroll'>
                                                        <Typography >
                                                            {data.AlertMessage}
                                                        </Typography>
                                                    </div>
                                                </Box>
                                                <Box className="action-detail" >
                                                    <FormLabel >Collection Category</FormLabel>
                                                    <Typography >
                                                        {data.CollectionCategoryName}
                                                    </Typography>
                                                </Box>

                                            </CardContent>
                                        </Card>
                                    </div>
                                    <div className='col-md-6 col-xxl-2'>
                                        <Card className='demoCard h-100' variant='outlined' >
                                            <CardHeader className='demoCardHead' title={<h6 className='text-start font-face-futura mb-0'><strong>Actions</strong></h6>} />
                                            <CardContent className='demoContent p-2'>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Assigned to</FormLabel>
                                                            <Typography >
                                                                {newWorklistDetails.AssignedTo}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Assigned by</FormLabel>
                                                            <Typography >
                                                                {newWorklistDetails.CommittedBy}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-12'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >What's Needed</FormLabel>
                                                            <Typography >
                                                                {newWorklistDetails.WhatsNeeded}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-12'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Due Date</FormLabel>
                                                            <Typography >
                                                                {formattedDueDate}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-12'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Timely Filing Date</FormLabel>
                                                            <Typography >
                                                                {data.TimelyFilingDate} <span>(180 Days)</span>
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                </div>

                                            </CardContent>
                                        </Card>
                                    </div>

                                </div>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion defaultExpanded className='bg-transparent single-accordion'>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3-content"
                                id="panel3-header"
                            >
                                <Typography component="span">Rule Violations</Typography>
                            </AccordionSummary>
                            <AccordionDetails className='px-0 border-bottom'>
                                <div className='row'>
                                    <div className='col-12 mb-2'>
                                        <Card className='demoCard h-100' variant='outlined' >
                                            <CardHeader className='demoCardHead' title={<h6 className='text-start font-face-futura mb-0'><strong>Processing Info</strong></h6>} />
                                            <CardContent className='demoContent p-2'>
                                                <div className='row'>
                                                    <div className="col-md-6 col-xxl-3">
                                                        <Box className="action-detail" >
                                                            <FormLabel >Scrubbed By</FormLabel>
                                                            <Typography >
                                                                {last_log?.first_name !== null ? last_log?.first_name + " " + last_log?.last_name : "System (Auto-Run)"}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className="col-md-6 col-xxl-3">
                                                        <Box className="action-detail" >
                                                            <FormLabel >Claim Scrubbed On</FormLabel>
                                                            <Typography >
                                                                {new Date(status[0].currentTime).toLocaleString('en-US')}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className="col-md-6 col-xxl-3">
                                                        <Box className="action-detail" >
                                                            <FormLabel >Multi-Practice Rules</FormLabel>
                                                            <Typography >
                                                                Total Active Rules:
                                                                <span> {status[0].rulesVoilated === false ? status[0].multiPracticeRuleCount : status[0]?.encounterRuleResult?.multiPracticeRuleCount}</span>
                                                            </Typography>
                                                            <Typography >
                                                                Rules Passed:
                                                                <span> {status[0].rulesVoilated === false ? status[0].multiPracticeRuleCount : status[0]?.encounterRuleResult?.multiPracticeRuleCount - multiPracticeRules.length}</span>
                                                            </Typography>
                                                            <Typography >
                                                                Rules Violated:
                                                                <span> {status[0].rulesVoilated === false ? 0 : multiPracticeRules.length}</span><br />
                                                                {isRPA?.length > 0 && <span className='spanTitle'>Rules Fixed:{'0 '}{ }</span>}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className="col-md-6 col-xxl-3">
                                                        <Box className="action-detail" >
                                                            <FormLabel >Practice Rules</FormLabel>
                                                            <Typography >
                                                                Total Active Rules:
                                                                <span> {status[0].rulesVoilated === false ? status[0].practiceRuleCount : status[0]?.encounterRuleResult?.practiceRuleCount}</span>
                                                            </Typography>
                                                            <Typography >
                                                                Rules Passed:
                                                                <span> {status[0].rulesVoilated === false ? status[0].practiceRuleCount : status[0]?.encounterRuleResult?.practiceRuleCount - practiceRules}</span>
                                                            </Typography>
                                                            <Typography >
                                                                Rules Violated:
                                                                <span> {status[0].rulesVoilated === false ? 0 : practiceRules - (this.state.RPA_response_data?.rpaResponse?.ruleFixed ? this.state.RPA_response_data?.rpaResponse?.ruleFixed : 0)}</span><br />
                                                                {isRPA?.length > 0 && <span className='spanTitle'>Rules Fixed: {this.state.RPA_response_data?.rpaResponse?.ruleFixed}</span>}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </div>
                                    {status?.map((result) => {
                                        // if (result.ruleSuccess === false) num++;
                                        if (result?.ruleSuccess === false && elStatus[0]?.isDuplicate === false) {
                                            num++;
                                        } else if (result?.ruleSuccess === false && elStatus[0]?.isDuplicate === true) {
                                            num = num + 2;
                                        };
                                        let ruleType = result?.practiceId == '0' ? 'Global' : 'Practice Specific'
                                        const createdDate = result?.encounterRuleResult?.ruleData?.created_at;
                                        const modifiedDate = result?.encounterRuleResult?.ruleData?.updated_at;

                                        let tiles = result?.encounterRuleResult?.ruleData?.ruleInfo?.filter(item => item.procedureTile);

                                        let globalPeriodRule = result?.encounterRuleResult?.ruleData?.ruleInfo?.filter(item => item.category === 'Global Period');
                                        // console.log(globalPeriodRule)

                                        var months = new Array(12);
                                        months[0] = "January";
                                        months[1] = "February";
                                        months[2] = "March";
                                        months[3] = "April";
                                        months[4] = "May";
                                        months[5] = "June";
                                        months[6] = "July";
                                        months[7] = "August";
                                        months[8] = "September";
                                        months[9] = "October";
                                        months[10] = "November";
                                        months[11] = "December";

                                        let created_date = new Date(createdDate);
                                        let created_month_value = created_date.getMonth();
                                        let created_day_value = created_date.getDate();
                                        let created_year_value = created_date.getFullYear();
                                        let created_date_value = months[created_month_value] + " " + created_day_value + ", " + created_year_value;

                                        let created_hours = created_date.getHours();
                                        let created_minutes = created_date.getMinutes();
                                        let created_ampm = created_hours >= 12 ? 'PM' : 'AM';
                                        created_hours = created_hours % 12;
                                        created_hours = created_hours ? created_hours : 12; // the hour '0' should be '12'
                                        created_minutes = created_minutes < 10 ? '0' + created_minutes : created_minutes;
                                        let createdTime = created_hours + ':' + created_minutes + ' ' + created_ampm;

                                        let modified_date = new Date(modifiedDate);
                                        let modified_month_value = modified_date.getMonth();
                                        let modified_day_value = modified_date.getDate();
                                        let modified_year_value = modified_date.getFullYear();
                                        let modified_date_value = months[modified_month_value] + " " + modified_day_value + ", " + modified_year_value;

                                        let modified_hours = modified_date.getHours();
                                        let modified_minutes = modified_date.getMinutes();
                                        let modified_ampm = modified_hours >= 12 ? 'PM' : 'AM';
                                        modified_hours = modified_hours % 12;
                                        modified_hours = modified_hours ? modified_hours : 12; // the hour '0' should be '12'
                                        modified_minutes = modified_minutes < 10 ? '0' + modified_minutes : modified_minutes;
                                        let modifiedTime = modified_hours + ':' + modified_minutes + ' ' + modified_ampm;

                                        return result?.ruleSuccess === false && (
                                            <div className='col-12 text-start'>
                                                <Typography component="span" className='page-heading fw-normal p-2 fs-5' >Rule Violation {num}</Typography>
                                                <Card className='demoCard' variant='outlined' >
                                                    <CardHeader className='demoCardHead'
                                                        title={
                                                            <div className='d-flex align-items-center gap-3'>

                                                                <h6 className='text-start font-face-futura mb-0'>
                                                                    <strong>{result?.encounterRuleResult?.ruleName}</strong>
                                                                </h6>
                                                                <div className='bug_img' onClick={() => this.handleEdit(result?.ruleId)}>
                                                                    <img src={edit} alt='edit' />
                                                                </div>
                                                                <div className='bug_img ms-auto' onClick={() => this.handleBugModal(result)}>
                                                                    <img src={bug} alt='bug' />
                                                                </div>
                                                            </div>
                                                        } />
                                                    <CardContent className='demoContent p-2'>
                                                        <div className='row'>
                                                            <div className='col-md-4 col-xxl-2'>
                                                                <Box className="action-detail" >
                                                                    <FormLabel>Date Created</FormLabel>
                                                                    <Typography>
                                                                        {created_date_value} {' '} ({createdTime})
                                                                    </Typography>
                                                                </Box>
                                                            </div>
                                                            <div className='col-md-4 col-xxl-2'>
                                                                <Box className="action-detail" >
                                                                    <FormLabel>Date Modified</FormLabel>
                                                                    <Typography>
                                                                        {modified_date_value} {' '} ({modifiedTime})
                                                                    </Typography>
                                                                </Box>
                                                            </div>
                                                            <div className='col-md-4 col-xxl-2'>
                                                                <Box className="action-detail" >
                                                                    <FormLabel>Version</FormLabel>
                                                                    <Typography>
                                                                        {result?.encounterRuleResult?.version}
                                                                    </Typography>
                                                                </Box>
                                                            </div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-md-4 col-xxl-2'>
                                                                <Box className="action-detail" >
                                                                    <FormLabel>Created By</FormLabel>
                                                                    <Typography>
                                                                        {result?.encounterRuleResult?.createdBy}
                                                                    </Typography>
                                                                </Box>
                                                            </div>
                                                            <div className='col-md-4 col-xxl-2'>
                                                                <Box className="action-detail" >
                                                                    <FormLabel>Modified By</FormLabel>
                                                                    <Typography>
                                                                        {result?.encounterRuleResult?.ruleData?.updatedBy}
                                                                    </Typography>
                                                                </Box>
                                                            </div>
                                                            <div className='col-md-4 col-xxl-2'>
                                                                <Box className="action-detail" >
                                                                    <FormLabel>Rule Type</FormLabel>
                                                                    <Typography>
                                                                        {ruleType}
                                                                    </Typography>
                                                                </Box>
                                                            </div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col-12'>
                                                                <Box className="action-detail" >
                                                                    <FormLabel>Rule</FormLabel>
                                                                    <Typography>
                                                                        When the {' '}
                                                                        {result?.encounterRuleResult?.ruleData?.ruleInfo?.map((item, idx) => {
                                                                            let error = "{{error}}";
                                                                            let procedureTileValue;
                                                                            let finalValues;
                                                                            let finalValues1;
                                                                            let procedureValues;
                                                                            let condition;
                                                                            switch (item.category) {
                                                                                case "Procedure Code":
                                                                                    switch (item.condition) {
                                                                                        case "is":
                                                                                            condition = "on the claim include any of the following";
                                                                                            break;
                                                                                        case "inclusionary is not":
                                                                                            condition = "on the claim are none of the following";
                                                                                            break;
                                                                                        case "exclusionary is not":
                                                                                            condition = "on the claim include a code other than the following";
                                                                                            break;
                                                                                        default:
                                                                                            break;
                                                                                    }
                                                                                    break;
                                                                                default:
                                                                                    condition = item.condition;
                                                                                    break;
                                                                            }

                                                                            switch (item.category) {
                                                                                case 'Diagnosis 1':
                                                                                case 'Diagnosis 2':
                                                                                case 'Diagnosis 3':
                                                                                case 'Diagnosis 4':
                                                                                case 'Diagnosis in any slot':
                                                                                case 'Modifier':
                                                                                case 'Units':
                                                                                case 'Unit Charge':
                                                                                case 'Total Charges':
                                                                                    procedureTileValue = item.procedureTile === 'any' ? 'for any procedure' : `for procedure tile ${item.procedureTile}`
                                                                                    break;
                                                                                default:
                                                                                    procedureTileValue = ""
                                                                                    break;
                                                                            }
                                                                            switch (item.category) {
                                                                                case 'Diagnosis 1':
                                                                                case 'Diagnosis 2':
                                                                                case 'Diagnosis 3':
                                                                                case 'Diagnosis 4':
                                                                                case 'Diagnosis in any slot':
                                                                                    finalValues = (condition === 'is' || condition === 'contains') ?
                                                                                        (item.values.map(val => val.name ? val.name.split('-')[0].trim() : val)).join(' or ') :
                                                                                        (condition === 'is missing') ? [] :
                                                                                            (item.values.map(val => val.name ? val.name.split('-')[0].trim() : val)).join(' and ');
                                                                                case 'Procedure Code':
                                                                                    finalValues = condition === 'is' ?
                                                                                        (item.values.map(val => val.name ? val.name.split('-')[0].trim() : val)).join(' or ') :
                                                                                        (item.values.map(val => val.name ? val.name.split('-')[0].trim() : val)).join(' and ');
                                                                                    break;
                                                                                default:
                                                                                    finalValues = (condition === 'is' || condition === 'contains') ?
                                                                                        (item.values.map(val => val.name ? val.name + ' ' + ((item.category === 'Primary Insurance Plan' || item.category === 'Secondary Insurance Plan') ? `(${val.id})` : (item.category === 'Scheduling Provider' || item.category === 'Rendering Provider' || item.category === 'Referring Provider') ? `(${val.id})` : '') : val)).join(' or ') :
                                                                                        (condition === 'is missing') ? [] :
                                                                                            (item.values.map(val => val.name ? val.name + ' ' + ((item.category === 'Primary Insurance Plan' || item.category === 'Secondary Insurance Plan') ? `(${val.id})` : (item.category === 'Scheduling Provider' || item.category === 'Rendering Provider' || item.category === 'Referring Provider') ? `(${val.id})` : '') : val)).join(' and ');
                                                                                    break;
                                                                            }
                                                                            switch (item.category) {
                                                                                case 'Global Period':
                                                                                    finalValues1 = (item.values.map(val => val.name ? val.name.split('-')[0].trim() : val)).join(' or ');
                                                                                    procedureValues = (item.procedureArray.map(val => val.name ? val.name.split('-')[0].trim() : val)).join(' or ');
                                                                                    break;
                                                                                default:
                                                                                    break;
                                                                            }
                                                                            return (<>
                                                                                {item.category === 'Global Period' ?
                                                                                    <>
                                                                                        <span>{item.category}</span>{' '}
                                                                                        <span>for the procedure(s)</span>{' '}
                                                                                        <span style={{ color: '#297200' }}>{finalValues1}</span>{' '}
                                                                                        <span>is within</span>{' '}
                                                                                        {item.days && (<span style={{ color: '#297200' }}>{item.days}{' '}</span>)}
                                                                                        <span>{(item.days === '0' || item.days === '1') ? 'day' : 'days'},</span>{' '}
                                                                                        <span>{item?.globalDrop}</span>{' '}
                                                                                        <span>we cannot bill the procedure(s)</span>{' '}
                                                                                        <span style={{ color: '#297200' }}>{procedureValues}{' '}</span>
                                                                                    </> :
                                                                                    <>
                                                                                        <span>{(idx > 0 || tiles.length > 0 ? ' the ' + item.category + ' ' + procedureTileValue : item.category + ' ' + procedureTileValue) + ' ' + condition}</span>{' '}
                                                                                        <span style={{ color: (finalValues.length === 0 && condition !== 'is missing') ? '#954437' : '#535353' }}>
                                                                                            {((finalValues && finalValues.length !== 0) || condition === 'is missing') ? finalValues : error}
                                                                                        </span>{' '}
                                                                                    </>
                                                                                }
                                                                                <span>{(item.operator).toLowerCase()}</span>
                                                                            </>)
                                                                        })} {result?.encounterRuleResult?.result}.
                                                                    </Typography>
                                                                </Box>
                                                            </div>
                                                        </div>

                                                        {globalPeriodRule.length > 0 && <div className='row'>
                                                            <div className='col-12'>
                                                                <Box className="action-detail" >
                                                                    <FormLabel>Bumping Against</FormLabel>
                                                                    <Typography>
                                                                        <span style={{ fontSize: 16 }}><b>Encounter:</b> {String(result?.encounterRuleResult?.bumpingEncounter).split(',').join(', ')}</span><br />
                                                                        <span style={{ fontSize: 16 }}><b>Patient Name:</b> {data.PatientName}</span><br />
                                                                        <span style={{ fontSize: 16 }}><b>Date of Service:</b> {String(result?.encounterRuleResult?.bumpingDOS).split(',').join(', ')}</span>
                                                                    </Typography>
                                                                    <FormLabel>Variables Violated</FormLabel>
                                                                    <Typography>
                                                                        <span style={{ fontSize: 16 }}><b>Procedures:</b> {String(result?.encounterRuleResult?.bumpingProcedureCodes).split(',').join(', ')}</span>
                                                                    </Typography>
                                                                </Box>
                                                            </div>
                                                        </div>}

                                                        <div className='row'>
                                                            <div className='col-12'>
                                                                {result?.encounterRuleResult?.result === 'pend to review tab' &&
                                                                    <Box className="action-detail" >
                                                                        <FormLabel>Reason</FormLabel>
                                                                        <Typography component="div">
                                                                            <div dangerouslySetInnerHTML={{ __html: result?.encounterRuleResult?.reason }} />
                                                                            {/* {result?.encounterRuleResult?.reason} */}
                                                                        </Typography>
                                                                    </Box>}
                                                                {result?.encounterRuleResult?.result === 'Run RPA Flow' &&
                                                                    <Box className="action-detail" >
                                                                        <FormLabel>Action</FormLabel>
                                                                        <Typography>
                                                                            <span style={{ fontSize: 14 }}><b>Action Taken:</b> </span><br />
                                                                            <span style={{ fontSize: 14 }}><b>RPA Flow Name:</b> </span><br />
                                                                            <span style={{ fontSize: 14 }}><b>Verify Authorization Line Note:</b> </span><br />
                                                                            <span style={{ fontSize: 14 }}><b>Operator:</b> </span><br />
                                                                            <span style={{ fontSize: 14 }}><b>Auth Note Field:</b> </span><br />
                                                                            <span style={{ fontSize: 14 }}><b>Add Batch Message if there is an error?:</b> </span><br />
                                                                            <span style={{ fontSize: 14 }}><b>Batch Message:</b> </span><br />
                                                                            <span style={{ fontSize: 14 }}><b>Add Error Note if there is an error?:</b> </span><br />
                                                                            <span style={{ fontSize: 14 }}><b>Error Message:</b> </span>
                                                                        </Typography>
                                                                        {this.state.RPA_response_data?.rpaStatus === "sent to RPA" &&
                                                                            <Box className="action-detail" >
                                                                                <FormLabel>Result</FormLabel>
                                                                                <Typography>
                                                                                    <span style={{ fontSize: 14 }}><b>RPA Result: Running...</b> </span><br />
                                                                                    <span style={{ fontSize: 14 }}><b>RPA Start: {new Date(this.state.RPA_response_data.createdAt).toLocaleString()}</b> </span>
                                                                                </Typography>
                                                                            </Box>}
                                                                        {this.state.RPA_response_data?.rpaStatus === "received but failed" &&
                                                                            <Box className="action-detail" >
                                                                                <FormLabel>Result</FormLabel>
                                                                                <Typography>
                                                                                    <span style={{ fontSize: 14 }}><b>RPA Result: </b>Failed</span><br />
                                                                                    <span style={{ fontSize: 14 }}><b>Error Code:</b> </span><br />
                                                                                    <span style={{ fontSize: 14 }}><b>Error Message: {JSON.stringify(this.state.RPA_response_data)}</b> </span><br />
                                                                                    <span style={{ fontSize: 14 }}><b>RPA Start: </b>{new Date(this.state.RPA_response_data.createdAt).toLocaleString()}</span><br />
                                                                                    <span style={{ fontSize: 14 }}><b>RPA End: </b>{new Date(this.state.RPA_response_data.updatedAt).toLocaleString()}</span>
                                                                                </Typography>
                                                                            </Box>}
                                                                        {this.state.RPA_response_data?.rpaStatus === "received and success" &&
                                                                            <Box className="action-detail" >
                                                                                <FormLabel>Action</FormLabel>
                                                                                <Typography>
                                                                                    <span style={{ fontSize: 14 }}><b>RPA Result: </b>Successful</span><br />
                                                                                    <span style={{ fontSize: 14 }}><b>RPA Start: </b>{new Date(this.state.RPA_response_data.createdAt).toLocaleString()}</span><br />
                                                                                    <span style={{ fontSize: 14 }}><b>RPA End: </b>{new Date(this.state.RPA_response_data.updatedAt).toLocaleString()}</span>
                                                                                </Typography>
                                                                            </Box>}
                                                                        {this.state.RPA_response_data?.rpaStatus === "error" &&
                                                                            <Box className="action-detail" >
                                                                                <FormLabel>Action</FormLabel>
                                                                                <Typography>
                                                                                    <span style={{ fontSize: 14 }}><b>RPA Result: </b>Error</span><br />
                                                                                    <span style={{ fontSize: 14 }}><b>Error Code:</b> {this.state.RPA_response_data.rpaResponse.error?.code.split()}</span><br />
                                                                                    <span style={{ fontSize: 14 }}><b>Error Message: </b> {this.state.RPA_response_data.rpaResponse?.error?.message.split(/\r?\n/)[0]}</span><br />
                                                                                    <span style={{ fontSize: 14 }}><b>RPA Start: </b>{new Date(this.state.RPA_response_data.createdAt).toLocaleString()}</span><br />
                                                                                    <span style={{ fontSize: 14 }}><b>RPA End: </b>{new Date(this.state.RPA_response_data.updatedAt).toLocaleString()}</span>
                                                                                </Typography>
                                                                            </Box>}
                                                                    </Box>}
                                                            </div>
                                                            <div className='col-12'>
                                                                <Box className="action-detail" >
                                                                    <FormLabel>Tags</FormLabel>
                                                                    <Typography>
                                                                        {(result?.encounterRuleResult?.tags).join(', ')}
                                                                    </Typography>
                                                                </Box>
                                                            </div>
                                                        </div>
                                                    </CardContent>
                                                </Card>
                                            </div>)
                                    })}
                                    <Dialog
                                        className='issue-popup-main'
                                        fullWidth={'lg'}
                                        maxWidth={'lg'}
                                        open={bugModal}
                                        onClose={this.closeBugModal}
                                    >
                                        <DialogTitle>
                                            <span className='reportIssue'>Report Issue</span>
                                            <div style={{ borderBottom: '1px solid #5CB02C' }}></div>
                                        </DialogTitle>
                                        <DialogContent>
                                            <Card className='issueCard'>
                                                <CardContent className='issueContent'>
                                                    <div className='mx-2 row'>
                                                        <div className='col-12 col-lg-12 col-sm-12'>
                                                            <label htmlFor='issue'><strong style={{ fontSize: '18px' }}>Please select the issue:</strong></label>
                                                            <select className='issue_select' name='issue' value={selectValue} onChange={this.handleSelectOption}>
                                                                <option value="claim">Claim didn't violate</option>
                                                                <option value="other">Other</option>
                                                            </select>
                                                        </div>
                                                        {isOther === false ? <div className='mt-3 col-12 col-lg-12 col-sm-12'>
                                                            <label htmlFor='rules'><strong style={{ fontSize: '18px' }}>Which rule(s) should have violated?</strong></label>
                                                            <select className='issue_select' value={rules}>
                                                                <option value="">Select</option>
                                                                {rules?.map((rule) => (
                                                                    <option key={rule.ruleId} value={rule.ruleName}>{rule.ruleName}</option>
                                                                ))}
                                                            </select>
                                                        </div> : <></>}
                                                        <div className='mt-3 col-12 col-lg-12 col-sm-12'>
                                                            <label htmlFor='info'><strong style={{ fontSize: '18px' }}>Please give us more information:</strong></label>
                                                            <textarea className='px-2 py-2 free_text' placeholder='Type here...'></textarea>
                                                        </div>
                                                    </div>
                                                </CardContent>
                                            </Card>
                                        </DialogContent>
                                        <footer>
                                            <div className='buttons'>
                                                <button className='activity_close_log'
                                                    onClick={this.closeBugModal}>
                                                    <span className='font-face-futura'>Close</span>
                                                </button>
                                                <button className='activity_submit_log'>
                                                    <span className='font-face-futura'>Submit</span>
                                                </button>
                                            </div>
                                        </footer>
                                    </Dialog>
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion defaultExpanded className='bg-transparent single-accordion'>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3-content"
                                id="panel3-header"
                            >
                                <Typography component="span" >Encounter Details</Typography>
                            </AccordionSummary>
                            <AccordionDetails className='px-0 border-bottom'>
                                <div className='row'>
                                    <div className='col-12 mb-2'>
                                        <Card className='demoCard h-100' variant='outlined' >
                                            <CardHeader className='demoCardHead' title={<h6 className='text-start font-face-futura mb-0'><strong>Encounter ID: <span>{data.EncounterID}</span></strong></h6>} />
                                            <CardContent className='demoContent p-2'>
                                                <div className='row'>
                                                    <div className='col-md-6 col-lg-4 col-xxl-3'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Practice Name</FormLabel>
                                                            <Typography >
                                                                {practice?.practiceName}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-md-6 col-lg-4 col-xxl-3'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Group NPI</FormLabel>
                                                            <Typography >
                                                                {practice?.groupNPI}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-md-6 col-lg-4 col-xxl-3'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Tax ID</FormLabel>
                                                            <Typography >
                                                                {practice?.taxId}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-md-6 col-lg-4 col-xxl-3'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Scheduling Provider</FormLabel>
                                                            <Typography >
                                                                {data.SchedulingProviderName}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-md-6 col-lg-4 col-xxl-3'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Rendering Provider</FormLabel>
                                                            <Typography >
                                                                {data.RenderingProviderName}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-md-6 col-lg-4 col-xxl-3'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Referring Provider</FormLabel>
                                                            <Typography >
                                                                {data.ReferringProviderName}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-md-6 col-lg-4 col-xxl-3'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Supervising Provider</FormLabel>
                                                            <Typography >
                                                                {data.SupervisingProviderName}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-md-6 col-lg-4 col-xxl-3'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Place of Service</FormLabel>
                                                            <Typography >
                                                                {data.ServiceLocationName}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-md-6 col-lg-4 col-xxl-3'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Place of Service Code</FormLabel>
                                                            <Typography >
                                                                {data.ServiceLocationPlaceOfServiceCode}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-md-6 col-lg-4 col-xxl-3'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Post Date</FormLabel>
                                                            <Typography >
                                                                {data.PostingDate}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-md-6 col-lg-4 col-xxl-3'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Created Date</FormLabel>
                                                            <Typography >
                                                                {data.CreatedDate.split(' ')[0]}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </div>
                                    <div className='col-12 mb-2'>
                                        <Card className='demoCard h-100' variant='outlined' >
                                            <CardHeader className='demoCardHead' title={<h6 className='text-start font-face-futura mb-0'><strong>Procedures</strong></h6>} />
                                            <CardContent className='demoContent p-2'>

                                                <Box className="actiontbl-container mb-2" style={{ height: "235px" }}>

                                                    <table className='denial-table'>
                                                        <thead>
                                                            <th className='text-center'>From</th>
                                                            <th className='text-center'>To</th>
                                                            <th className='text-center'>Procedure</th>
                                                            <th className='text-center'>Mod 1</th>
                                                            <th className='text-center'>Mod 2</th>
                                                            <th className='text-center'>Units</th>
                                                            <th className='text-center'>Unit Charge</th>
                                                            <th className='text-center'>Total Charge</th>
                                                            <th className='text-center'>Diag 1</th>
                                                            <th className='text-center'>Diag 2</th>
                                                            <th className='text-center'>Diag 3</th>
                                                            <th className='text-center'>Diag 4</th>
                                                        </thead>
                                                        <tbody>
                                                            {procedureData.map((data) => (
                                                                <tr className='text-center'>
                                                                    <td>{data.ServiceStartDate}</td>
                                                                    <td>{data.ServiceEndDate}</td>
                                                                    <td>{data.ProcedureCode}</td>
                                                                    <td>{data.ProcedureModifier1}</td>
                                                                    <td>{data.ProcedureModifier2}</td>
                                                                    <td>{Number(parseFloat(data.Units).toFixed(2)).toString()}</td>
                                                                    <td>{Number(parseFloat(data.UnitCharge).toFixed(2)).toString()}</td>
                                                                    <td>{data.TotalCharges !== ""
                                                                        ? Number(parseFloat(data.TotalCharges).toFixed(2)).toString()
                                                                        : data.TotalCharges}</td>
                                                                    <td>{data.EncounterDiagnosisID1}</td>
                                                                    <td>{data.EncounterDiagnosisID2}</td>
                                                                    <td>{data.EncounterDiagnosisID3}</td>
                                                                    <td>{data.EncounterDiagnosisID4}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </div>
                                    <div className='col-12'>
                                        <Card className='demoCard h-100' variant='outlined' >
                                            <CardHeader className='demoCardHead' title={<h6 className='text-start font-face-futura mb-0'><strong>Hospitalization Dates</strong></h6>} />
                                            <CardContent className='demoContent p-2'>
                                                <div className='row'>
                                                    <div className='col-6'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Start Date</FormLabel>
                                                            <Typography >
                                                                {data.HospitalizationStartDate}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-6'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >End Date</FormLabel>
                                                            <Typography >
                                                                {data.HospitalizationEndDate}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </div>

                                </div>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion defaultExpanded className='bg-transparent single-accordion'>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3-content"
                                id="panel3-header"
                            >
                                <Typography component="span" >Insurance</Typography>
                            </AccordionSummary>
                            <AccordionDetails className='px-0 border-bottom'>
                                <div className='row'>
                                    <div className='col-12 mb-2'>
                                        <Card className='demoCard h-100' variant='outlined' >
                                            <CardHeader className='demoCardHead' title={<h6 className='text-start font-face-futura mb-0'><strong>Case Details</strong></h6>} />
                                            <CardContent className='demoContent p-2'>
                                                <div className='row'>
                                                    <div className='col-4'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Case Name</FormLabel>
                                                            <Typography >
                                                                {data.CaseName}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-8'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Description</FormLabel>
                                                            <Typography >
                                                                {data.DefaultCaseDescription}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-12'>
                                                        <Box className="actiontbl-container mb-2" style={{ height: "200px" }}>
                                                            <table className='denial-table'>
                                                                <thead>
                                                                    <th className='text-center'>Order</th>
                                                                    <th className='text-center'>Insurance Company</th>
                                                                    <th className='text-center'>Insurance Plan</th>
                                                                    <th className='text-center'>Policy #</th>
                                                                    <th className='text-center'>Group #</th>
                                                                    <th className='text-center'>Phone #</th>
                                                                </thead>
                                                                <tbody style={{ height: "152px" }}>
                                                                    {data.PrimaryInsurancePolicyCompanyName && <tr className='text-center'>
                                                                        <td>1</td>
                                                                        <td>{data.PrimaryInsurancePolicyCompanyName}</td>
                                                                        <td>{data.PrimaryInsurancePlanName}</td>
                                                                        <td>{data.PrimaryInsurancePolicyNumber}</td>
                                                                        <td>{data.PrimaryInsurancePolicyGroupNumber}</td>
                                                                        <td>{data.PrimaryInsurancePolicyPlanPhoneNumber}</td>
                                                                    </tr>}
                                                                    {data.SecondaryInsurancePolicyCompanyName && <tr className='text-center'>
                                                                        <td>2</td>
                                                                        <td>{data.SecondaryInsurancePolicyCompanyName}</td>
                                                                        <td>{data.SecondaryInsurancePlanName}</td>
                                                                        <td>{data.SecondaryInsurancePolicyNumber}</td>
                                                                        <td>{data.SecondaryInsurancePolicyGroupNumber}</td>
                                                                        <td>{data.SecondaryInsurancePolicyPlanPhoneNumber}</td>
                                                                    </tr>}
                                                                </tbody>
                                                            </table>
                                                        </Box>
                                                    </div>

                                                </div>
                                            </CardContent>
                                        </Card>
                                    </div>
                                    <div className='col-12 '>
                                        <Card className='demoCard h-100' variant='outlined' >
                                            <CardHeader className='demoCardHead' title={<h6 className='text-start font-face-futura mb-0'><strong>Patient Gurantor Details</strong></h6>} />
                                            <CardContent className='demoContent p-2'>
                                                <div className='row'>
                                                    <div className='col-3'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Patient Relationship to Insured</FormLabel>
                                                            <Typography >
                                                                {data.PrimaryInsurancePolicyPatientRelationshipToInsured}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-2'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Name</FormLabel>
                                                            <Typography >
                                                                {data.PrimaryInsurancePolicyPatientRelationshipToInsured == 'S' ?
                                                                    data.PatientName : data.PrimaryInsurancePolicyInsuredFullName}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-2'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Gender</FormLabel>
                                                            <Typography >
                                                                {data.PrimaryInsurancePolicyPatientRelationshipToInsured == 'S' ?
                                                                    data.Gender : data.PrimaryInsurancePolicyInsuredGender}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-2'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Date of Birth</FormLabel>
                                                            <Typography >
                                                                {data.PrimaryInsurancePolicyPatientRelationshipToInsured == 'S' ?
                                                                    data.PatientDateOfBirth : data.PrimaryInsurancePolicyInsuredDateOfBirth}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                    <div className='col-3'>
                                                        <Box className="action-detail" >
                                                            <FormLabel >Address</FormLabel>
                                                            <Typography >
                                                                {data.PrimaryInsurancePolicyPatientRelationshipToInsured == 'S' ?
                                                                    data.AddressLine1 + ' ' + data.AddressLine2 :
                                                                    data.PrimaryInsurancePolicyInsuredAddressLine1 + ' ' + data.PrimaryInsurancePolicyInsuredAddressLine2}
                                                            </Typography>
                                                            <Typography >
                                                                {data.PrimaryInsurancePolicyPatientRelationshipToInsured == 'S' ?
                                                                    data.City + ' ' + data.Country + ' ' + data.ZipCode :
                                                                    data.PrimaryInsurancePolicyInsuredCity + ' ' + data.PrimaryInsurancePolicyInsuredCountry + ' ' + data.PrimaryInsurancePolicyInsuredZipCode}
                                                            </Typography>
                                                        </Box>
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion defaultExpanded className='bg-transparent single-accordion'>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3-content"
                                id="panel3-header"
                            >
                                <Typography component="span" >Patient Documents</Typography>
                            </AccordionSummary>
                            <AccordionDetails className='px-0 '>
                                <div className='row'>
                                    <div className='col-12'>
                                        <Card className='demoCard h-100' variant='outlined' >
                                            <CardHeader className='demoCardHead' title={<h6 className='text-start font-face-futura mb-0'><strong>Document History</strong></h6>} />
                                            <CardContent className='demoContent p-2 '>

                                                <Box className="actiontbl-container document-tbl mb-2" style={{ height: "350px" }}>

                                                    <table className='denial-table'>
                                                        <thead>
                                                            <th className='text-center'>Date Uploaded</th>
                                                            <th className='text-center'>Uploaded By</th>
                                                            <th className='text-center'>Document Type</th>
                                                            <th className='text-center'>Document Name</th>
                                                            <th className='text-center'>Actions</th>
                                                        </thead>
                                                        <tbody style={{ height: "250px" }}>
                                                            {documents?.length > 0 && documents?.map((doc) => (
                                                                <tr className='text-center'>
                                                                    <td>{new Date(doc.created_at).toLocaleDateString('en-US')}</td>
                                                                    <td>{JSON.parse(sessionStorage.getItem('userDetail'))?.Name}</td>
                                                                    <td>{doc.documentType}</td>
                                                                    <td>{doc.documentName}</td>
                                                                    <td>
                                                                        <div className='d-flex align-items-center gap-2 justify-content-center'>
                                                                            <img
                                                                                src={openDoc}
                                                                                alt="open"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => this.retrieveDocument(doc.s3Bucket, doc.s3Key, doc.documentType, 'view')}
                                                                            />
                                                                            <img
                                                                                src={download}
                                                                                alt="open"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => this.retrieveDocument(doc.s3Bucket, doc.s3Key, doc.documentType, 'download', doc.documentName)}
                                                                            />
                                                                            <img
                                                                                src={trash}
                                                                                alt="open"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => this.deleteDocument(doc.id)}
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>

                                                </Box>
                                                <Stack direction={'row'} justifyContent={'end'} spacing={2} className='action-footer'>
                                                    <span className="denial-forminput">
                                                        <label className="text-nowrap">Document Type</label>
                                                        <select
                                                            name="docs"
                                                            value={documentType}
                                                            onChange={(e) => this.setState({ documentType: e.target.value })}
                                                            className="denialSelect2"
                                                        >
                                                            <option value="" selected>Select</option>
                                                            {documentTypes.map(doc => (
                                                                <option key={doc.key} value={doc.value}>{doc.value}</option>
                                                            ))}
                                                        </select>
                                                        <input
                                                            type="file"
                                                            ref={this.fileInputRef}
                                                            style={{ display: 'none' }}
                                                            accept=".pdf, .doc, .docx"
                                                            onChange={this.handleFileChange}
                                                        />
                                                    </span>
                                                    <Button variant="contained" className='btn action-uploadbtn text-white' onClick={this.handleUploadButtonClick}>
                                                        <span>Upload</span>
                                                    </Button>
                                                </Stack>

                                            </CardContent>
                                        </Card>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>
            </section>
        )
    }
}

export default PatientDetails;